import {
  geckoPerms,
  PERMISSION_GECKO_INTERNAL_MEMBER,
} from 'features/auth/permissions/rolodexPermissionsList'
import { RolodexUserMetadata } from 'types'

export const computePermissions = (
  userMetadata: RolodexUserMetadata
): {
  permissions: Set<string>
} => {
  const permissions = userMetadata.roles.map((role) => role.name)
  const maskedPermissions = new Set(permissions)
  if (!permissions.includes(PERMISSION_GECKO_INTERNAL_MEMBER)) {
    geckoPerms.forEach((p) => maskedPermissions.delete(p))
  }
  return { permissions: maskedPermissions }
}

// From the Auth0 React Library
const CODE_RE = /[?&]code=[^&]+/
const STATE_RE = /[?&]state=[^&]+/
const ERROR_RE = /[?&]error=[^&]+/

export const hasLoginAuthParams = (
  searchParams = window.location.search
): boolean =>
  (CODE_RE.test(searchParams) || ERROR_RE.test(searchParams)) &&
  STATE_RE.test(searchParams)

// TODO: Done in keycloak, but not in Auth0 or Cognito. We should use this in
// all vendors to reduce rerenders
export class AuthState {
  authorization: string = ''
  tokenExpiration: Date = new Date()
}
